<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";

export default {
  data() {
    return {
      vueAppClasses: [],
    };
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
  },
  methods: {
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
  },
  mounted() {
    console.log("Route ", this.$route.path);
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  },
  async created() {
    let dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);
    // this.$moment.locale("ar");
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss">
.el-notification.right {
  z-index: 9999000 !important;
}

.el-table td,
.el-table th {
  padding: 2px 0 !important;
}
@font-face {
  font-family: "Cairo";
  src: url("./assets/fonts/din-next-regular.ttf");
}
@font-face {
  font-family: "din-bold";
  src: url("./assets/fonts/din-next-bold.ttf");
}

.home .el-container .el-tabs__nav {
  float: left !important;
}

.el-loading-spinner {
  text-align: center !important;
}
.el-icon-loading {
  text-align: center !important;
}
.el-loading-text {
  text-align: center !important;
}
* {
  font-family: "Cairo";
  text-align: -webkit-auto !important;
}
.el-aside {
  width: auto !important;
}
.vx-navbar-wrapper {
  z-index: 100 !important;
}
.el-form-item__label {
  float: left !important;
}
</style>
<style lang="scss" >
@import "styles/override.scss";
@import "styles/main.scss";

.el-button--warning {
  background: rgba(var(--vs-primary), 1) !important;
  border-color: rgba(var(--vs-primary), 1) !important;
  color: #fff !important;
  &:hover {
    background: rgba(var(--vs-primary), 1) !important;
    border-color: rgba(var(--vs-primary), 1) !important;
  }
}

.el-select-dropdown__item {
  &:hover {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
  }
}

.el-table__empty-text {
  text-align: center !important;
}

.el-select-dropdown__wrap {
  margin-bottom: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

#content-area .content-wrapper {
  background: #f6f6f66b !important;
}
.justify-content-between {
  justify-content: space-between !important;
}
.align-center {
  align-items: center !important;
}
.text-right {
  text-align: right !important;
}

</style>
